import { render, staticRenderFns } from "./SafeSelect.vue?vue&type=template&id=3acd8010&"
import script from "./SafeSelect.vue?vue&type=script&lang=js&"
export * from "./SafeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports